import { createAction } from "redux-actions";
import { moduleSlug } from "modules/Metric/services/constants";

export const clearMetric = createAction(`${moduleSlug}/CLEAR_METRIC`);

export const updateMetric = createAction(`${moduleSlug}/UPDATE_METRIC`);

export const setPercentProgress = createAction(`${moduleSlug}/SET_PERCENT_PROGRESS`);

export const getMetricTasks = createAction(`${moduleSlug}/GET_METRIC_TASKS`);
export const getMetricTasksSuccess = createAction(`${moduleSlug}/GET_METRIC_TASKS/SUCCESS`);
export const getMetricTasksError = createAction(`${moduleSlug}/GET_METRIC_TASKS/ERROR`);

export const getMetricDataByTask = createAction(`${moduleSlug}/GET_METRIC_DATA_BY_TASKS`);
export const getMetricDataByTaskSuccess = createAction(`${moduleSlug}/GET_METRIC_DATA_BY_TASKS/SUCCESS`);
export const getMetricDataByTaskError = createAction(`${moduleSlug}/GET_METRIC_DATA_BY_TASKS/ERROR`);

export const clearMetricData = createAction(`${moduleSlug}/CLEAR_METRIC_DATA`);

export const getMetricTaskByCode = createAction(`${moduleSlug}/GET_METRIC_TASK_BY_CODE`);

export const refreshMetricTaskInfo = createAction(`${moduleSlug}/REFRESH_METRIC_TASK_INFO`);

export const updateMetricTaskInfo = createAction(`${moduleSlug}/UPDATE_METRIC_TASK_INFO`);

export const setMetricGraphDialog = createAction(`${moduleSlug}/SET_METRIC_GRAPH_DIALOG`);

export const setUpdateMetricTaskDialog = createAction(`${moduleSlug}/SET_UPDATE_METRIC_TASK_DIALOG`);
export const mergeUpdateMetricTaskDialog = createAction(`${moduleSlug}/MERGE_UPDATE_METRIC_TASK_DIALOG`);

export const getTaskByCode = createAction(`${moduleSlug}/GET_TASK_BY_CODE`);
export const getTaskByCodeSuccess = createAction(`${moduleSlug}/GET_TASK_BY_CODE/SUCCESS`);
export const getTaskByCodeError = createAction(`${moduleSlug}/GET_TASK_BY_CODE/ERROR`);

export const clearTask = createAction(`${moduleSlug}/CLEAR_TASK`);

export const createMetricTask = createAction(`${moduleSlug}/CREATE_METRIC_TASK`);
export const updateMetricTask = createAction(`${moduleSlug}/UPDATE_METRIC_TASK`);
export const deleteMetricTask = createAction(`${moduleSlug}/DELETE_METRIC_TASK`);

export const formUpdateMetricTask = createAction(`${moduleSlug}/FORM_UPDATE_METRIC_TASK`);
